// src/ai/AIPreferenze.js

import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import "../Dashboard.css";
import "./ai.css";

import {
  getLocaleTagCorrente,
  caricaPreferenzeAI,
  salvaPreferenzeAI,
  caricaMenuLocale,
} from "../api/aiService";

function AIPreferenze() {
  const [localeTag, setLocaleTag] = useState("");
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [esito, setEsito] = useState("");

  const [obiettivo, setObiettivo] = useState("equilibrato");
  const [tono, setTono] = useState("normale");
  const [intensita, setIntensita] = useState("moderata");
 
  const [menuLocale, setMenuLocale] = useState([]);
  const [piattiDaSpingere, setPiattiDaSpingere] = useState([]);
  const [regoleSuggerimenti, setRegoleSuggerimenti] = useState({});

  const [categoriaAttiva, setCategoriaAttiva] = useState("tutte");
  const [ricercaTesto, setRicercaTesto] = useState("");

  // ========================= INIT =========================
  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);


        const forcedLocale =
          localStorage.getItem("forcedLocale");

        const tag =
          forcedLocale ||
          await getLocaleTagCorrente();

        setLocaleTag(tag);

        const prefs = await caricaPreferenzeAI(tag);
        if (prefs) {
          setObiettivo(prefs.obiettivo || "equilibrato");
          setTono(prefs.tono || "normale");
          setIntensita(prefs.intensita || "moderata");
          setPiattiDaSpingere(prefs.piatti_da_spingere || []);
          setRegoleSuggerimenti(prefs.regole_suggerimenti || {});
        }

        const menu = await caricaMenuLocale(tag);
        setMenuLocale(menu);
      } catch (err) {
        setErrore(err.message || "Errore nel caricamento dati AI.");
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  // ========================= SALVA =========================
  const handleSalva = async () => {
    try {
      setSalvando(true);
      setErrore("");
      setEsito("");

await salvaPreferenzeAI({
  localeTag,
  preferenze: {
    obiettivo,
    tono,
    intensita,
    piatti_da_spingere: piattiDaSpingere,
    regole_suggerimenti: regoleSuggerimenti,
  },
});

      setEsito("Preferenze AI salvate con successo");
    } catch (err) {
      setErrore("Errore durante il salvataggio");
    } finally {
      setSalvando(false);
    }
  };

  // ========================= FILTRI =========================
  const categorieUniche = [
    "tutte",
    ...Array.from(
      new Set(
        menuLocale
          .map((p) => {
            if (typeof p.categoria === "string") {
              return p.categoria.trim();
            }
            if (typeof p.categoria === "object") {
              return p.categoria?.it || p.categoria?.en || "";
            }
            return "";
          })
          .filter(Boolean)
      )
    ),
  ];

  const piattiFiltrati = menuLocale
    .filter((p) => {
      const cat =
        typeof p.categoria === "string"
          ? p.categoria
          : p.categoria?.it || p.categoria?.en || "";

      return categoriaAttiva === "tutte" || cat === categoriaAttiva;
    })
    .filter((p) => {
      // p.nome può essere stringa o oggetto multilingua {it: "...", en: "..."}
      const nomeStr = typeof p.nome === "string"
        ? p.nome
        : (p.nome?.it || p.nome?.en || Object.values(p.nome || {})[0] || "");
      return nomeStr.toLowerCase().includes(ricercaTesto.toLowerCase());
    });

  // ========================= RENDER =========================
  return (
    <>
      <Navbar />

      <div className="container page-with-navbar ai-page-root responsive-gestore-container">

        <div className="ai-assistant-compact">
          <h2 className="ai-compact-title">🤖 Configurazione Assistente AI</h2>
          <p className="ai-compact-subtitle">
            Definisci la strategia con cui l’AI guiderà le scelte dei tuoi clienti.
          </p>
        </div>

        {loading ? (
          <div className="ai-card">🔄 Caricamento impostazioni...</div>
        ) : errore ? (
          <div className="ai-card ai-card-error">{errore}</div>
        ) : (
          <>
 {/* STRATEGIA */}
<div className="ai-card">
  <h3 className="ai-section-title">🎯 Strategia AI</h3>

  <label>Obiettivo</label>
  <div className="ai-segment">
    {["equilibrato", "upselling", "cross-selling", "fidelizzazione"].map((opt) => (
      <div
        key={opt}
        className={`ai-option ${obiettivo === opt ? "active" : ""}`}
        onClick={() => setObiettivo(opt)}
      >
        {opt.replace("-", " ")}
      </div>
    ))}
  </div>

  <label style={{ marginTop: "1rem" }}>Intensità</label>
  <div className="ai-segment">
    {["soft", "moderata", "aggressiva"].map((opt) => (
      <div
        key={opt}
        className={`ai-option ${intensita === opt ? "active" : ""}`}
        onClick={() => setIntensita(opt)}
      >
        {opt.charAt(0).toUpperCase() + opt.slice(1)}
      </div>
    ))}
  </div>

  <label style={{ marginTop: "1rem" }}>Tono</label>
  <div className="ai-segment">
    {["breve", "normale", "premium"].map((opt) => (
      <div
        key={opt}
        className={`ai-option ${tono === opt ? "active" : ""}`}
        onClick={() => setTono(opt)}
      >
        {opt.charAt(0).toUpperCase() + opt.slice(1)}
      </div>
    ))}
  </div>
</div>

            {/* PIATTI PRIORITARI */}
            <div className="ai-card">
              <h3 className="ai-section-title">
                ⭐ Piatti prioritari
                <span style={{
                  marginLeft: "0.5rem",
                  fontSize: "0.9rem",
                  fontWeight: 500,
                  color: piattiDaSpingere.length === 10 ? "#ef4444" : "rgba(255,255,255,0.7)"
                }}>
                  ({piattiDaSpingere.length}/10)
                </span>
              </h3>

              <div className="ai-subtitle">Filtra per categoria</div>
              <div className="ai-segment">
                {categorieUniche.map((cat) => (
                  <div
                    key={cat}
                    className={`ai-option ${categoriaAttiva === cat ? "active" : ""}`}
                    onClick={() => setCategoriaAttiva(cat)}
                  >
                    {cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </div>
                ))}
              </div>

              <label style={{ marginTop: "1rem" }}>Cerca piatto</label>
              <input
                type="text"
                className="ai-search"
                placeholder="Scrivi per filtrare..."
                value={ricercaTesto}
                onChange={(e) => setRicercaTesto(e.target.value)}
              />

              <div className="menu-dishes-grid">
                {piattiFiltrati.map((p) => {
                  const attivo = piattiDaSpingere.some((x) => x.id === p.id);

                  return (
                    <div
                      key={p.id}
                      className={`dish-option ${attivo ? "active" : ""}`}
                      onClick={() => {
                        if (attivo) {
                          setPiattiDaSpingere(
                            piattiDaSpingere.filter((x) => x.id !== p.id)
                          );
                        } else if (piattiDaSpingere.length < 10) {
                          setPiattiDaSpingere([
                            ...piattiDaSpingere,
                            { id: p.id, nome: p.nome },
                          ]);
                        }
                      }}
                    >
                      {typeof p.nome === "string"
                        ? p.nome
                        : p.nome?.it || p.nome?.en || Object.values(p.nome || {})[0] || ""}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* REGOLE SUGGERIMENTI */}
            <div className="ai-card">
              <h3 className="ai-section-title">🧠 Regole suggerimenti</h3>

              {categorieUniche.filter(c => c !== "tutte").map((cat) => (
                <div key={cat} style={{ marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 600, marginBottom: "0.3rem" }}>
                    Se cliente sceglie: {cat.charAt(0).toUpperCase() + cat.slice(1)}
                  </div>

                  <div className="ai-segment" style={{ flexWrap: "wrap" }}>
                    {categorieUniche
                      .filter(c => c !== "tutte" && c !== cat)
                      .map((target) => {
                        const attivo =
                          regoleSuggerimenti[cat]?.includes(target) || false;

                        return (
                          <div
                            key={target}
                            className={`ai-option ${attivo ? "active" : ""}`}
                            onClick={() => {
                              const current = regoleSuggerimenti[cat] || [];

                              if (attivo) {
                                setRegoleSuggerimenti({
                                  ...regoleSuggerimenti,
                                  [cat]: current.filter((c) => c !== target),
                                });
                              } else {
                                setRegoleSuggerimenti({
                                  ...regoleSuggerimenti,
                                  [cat]: [...current, target],
                                });
                              }
                            }}
                          >
                            {target}
                          </div>
                        );
                      })}
                  </div>
                </div>
              ))}
            </div>

            <button
              className="ai-compact-btn"
              onClick={handleSalva}
              disabled={salvando}
            >
              {salvando ? "Salvataggio..." : "💾 Salva configurazione AI"}
            </button>

            {esito && <div className="ai-success-message">{esito}</div>}
          </>
        )}
      </div>
    </>
  );
}

export default AIPreferenze;